import React, { useState, useEffect, useRef, useContext } from 'react'
import { Button, Calendar, ConfirmDialog, Dialog, InputText, Password, Tag, Toast, confirmDialog } from 'primereact';

import { getListPersonal, getListadoAutoriza, getListadoTipoPermiso, crearPermisoRRHH, getListadoEstadosPermiso, cancelarPermisos, autorizarPermisoRH, getListadoPermisosAprobarGerencia, getListadoPermisosAprobarRRHH } from '../../../API/RRHH/Personal/PermisosPersonal/PermisosPersonalRequests'

import { getDateTimeStringSQL } from '../../../Base/Services/Moment/Luxon';
import AutoCompleteDropdown from '../../../Base/Components/Form/AutoCompleteDropdown';
import { toastShow } from '../../../Base/Services/ToastService';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import Card from '../../../Base/Components/Card/Card';
import { useForm } from '../../../Base/Hooks/useForm';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import { setTitlePage } from '../../../Base/Services/Config/ConfigService';



const AprobarPermisosPersonalGerencia = (props) => {
    const {userAuth} = useContext(AuthContext);

    const permiso = 1

    const toastDialog = useRef(null);
    const toast = useRef(null);

    const [listado, setListado] = useState([]);
    const [loading, setLoading] = useState(false);
    const [personal, setPersonal] = useState([]);
    const [tipoPermisos, setTipoPermisos] = useState([]);
    const [listAutoriza, setListAutoriza] = useState([]);
    const [show, setShow] = useState(false);
    const [selected, setSelected] = useState([]);
    const [dialogAuth, setDialogAuth] = useState(false);
    const [password, setPassword] = useState('');


    const {values, handleInputChange, resetForm, error, setError} = useForm({
        Personal: null,
        Tipo: null,
        Observaciones: '',
        Autoriza: null,
        FechaPermiso: new Date()
    });

    const getInitialValues = async () => {
        setLoading(true);

        const a = await getListadoAutoriza(userAuth.Usuario);
        setListAutoriza(a);

        const t = await getListadoTipoPermiso();
        setTipoPermisos(t);

        getInfo();
        setLoading(false);
    }

    const getInfo = async () => {
        setLoading(true);
        const esta = await getListadoEstadosPermiso()
        const per = await getListPersonal(userAuth.Usuario);
        const p = per.map(e => { return { ...e, Concat: e.Codigo + ' - ' + e.Nombre } })
        setPersonal(p);
        let listT = [];
        console.log({permiso});
        switch (permiso) {
            case 1:
                listT = await getListadoPermisosAprobarGerencia(userAuth.Usuario);
                break;
            case 2:
                listT = await getListadoPermisosAprobarRRHH();
                break;
            default:
                break;
        }
        const list = listT.map(t => {
            return {
                ...t,
                Permiso: p.filter(e => e.Id === t.TipoPermiso),
                NameEstado: esta.filter(i => i.Id === t.Estado)[0]?.Estado
            }
        })
        setListado(list);
        setLoading(false);
    }

    const showModal = () => {
        setShow(true);
    }

    const onHide = () => {
        resetForm();
        setShow(false);
        setDialogAuth(false);
        setPassword('')
    }



    const verificarInfo = () => {
        let error = {}
        if (values.FechaPermiso === null || values.FechaPermiso === undefined) {
            error.FechaPermiso = true;
            error.error = true;
        }
        if (values.Personal === null) {
            error.Personal = true;
            error.error = true;
        }
        if (values.Tipo === null) {
            error.Tipo = true;
            error.error = true;
        }
        if (values.Autoriza === null) {
            error.Autoriza = true;
            error.error = true;
        }
        if (values.Observaciones === null) {
            error.Observaciones = true;
            error.error = true;
        }
        setError(error);
        console.log(error);
        return error
    }

    const crearPermiso = async () => {
        const e = verificarInfo();
        if (!e.error) {
            const a = {
                "ID": -1,
                "Correlativo": null,
                "IdPersonal": values.Personal.Codigo,
                "FechaPermiso": getDateTimeStringSQL(values.FechaPermiso),
                "TipoPermiso": values.Tipo.Id,
                "Observaciones": values.Observaciones,
                "IdEstado": 1,
                "Autoriza": values.Autoriza.Codigo,
                "FechaReal": null,
                "HoraReal": null,
                "FirmaGA": null,
                "FirmaRH": null,
                "Mail": null
            }
            const t = await crearPermisoRRHH(a);
            console.log(t);
            getInfo();
            onHide();
            toastShow(toast, 'success', 'Permiso creado');
        } else {
            toastShow(toastDialog, 'warn', 'Debe de completar todos los campos.')
        }
    }

    const estadoTemplate = (rowData) => {
        switch (rowData.Estado) {
            case 1:
                return <Tag className='col-12' value={rowData.NameEstado} />
            case 2:
                return <Tag className='col-12' value={rowData.NameEstado} severity='info' />
                break;
            case 3:
                return <Tag className='col-12' value={rowData.NameEstado} severity='success' />
                break;
            case 5:
                return <Tag className='col-12' value={rowData.NameEstado} severity='danger' />
                break;

            default:
                return null
                break;
        }
    }

    const columns = [
        {
            header: 'Correlativo',
            field: 'Correlativo',
            className: 'small'
        },
        {
            header: 'Código',
            field: 'Codigo',
            className: 'Xsmall'
        },
        {
            header: 'Nombre',
            field: 'Nombre',
            className: 'Xlarge',
            Sumary: 'count'
        },
        {
            header: 'Seccion',
            field: 'Seccion',
            className: 'small'
        },
        {
            header: 'TipoPermiso',
            field: 'TipoPermiso',
            // Format: 'Template',
            // filter: true,
            // body: e => {console.log(tipoPermisos.filter(t => t.Id === e.TipoPermiso), e.TipoPermiso); return <span>{}</span> }
            // // {tipoPermisos.filter(t => t.Id === e.TipoPermiso)}
        },
        {
            header: 'Fecha',
            field: 'FechaWeb',
            Format: 'Date'
        },
        {
            header: 'Observaciones',
            field: 'Observaciones',
        },
        // {
        //     header: 'Autoriza',
        //     field: 'NombreAutoriza',
        // },
        {
            header: 'Estado',
            field: 'NameEstado',
            className: 'small',
            Format: 'Template',
            body: estadoTemplate
        },
        {
            header: 'CorreEnviado',
            field: 'CorreoEnviado',
            Format: 'Checkbox',
            className: 'small'
        },
        {
            header: 'FirmaGA',
            field: 'FirmaGA',
            Format: 'Checkbox',
            className: 'small',
            frozen: true,
            alignFrozen: 'right',
            disabled: permiso !== 2,
            onChange: (e, rowData) => {
                if (selected.length === 0) {
                    setSelected([rowData.data])
                }
                setDialogAuth(true)
            }
        },
        {
            header: 'FirmaRH',
            field: 'FirmaRH',
            Format: 'Checkbox',
            className: 'small',
            disabled: permiso !== 1,
            frozen: true,
            alignFrozen: 'right',
            onChange: (e, rowData) => {
                if (selected.length === 0) {
                    setSelected([rowData.data])
                }
                setDialogAuth(true)
            }
        },
    ]

    const table = {
        Columns: columns,
        Data: listado,
        loading: loading,
        selected: selected,
        setSelected: setSelected
    }


    const changePermiso = async () => {
        let a = null
        a = await autorizarPermisoRH(selected, false, password, userAuth?.idPersonal)
        console.log(a);
        if (a) {
            toastShow(toast, 'success', 'Permisos actualizados')

            getInfo();
        } else {
            toastShow(toast, 'error', 'Credenciales incorrectas.')
        }
        onHide()
    }

    const FooterCrear = () => {
        return <div>
            <Button icon='pi pi-times' label='Cancelar' className='p-button-secondary' onClick={onHide} />
            <Button icon='pi pi-save' label='Crear' className='p-button-success' onClick={crearPermiso} />
        </div>
    }


    useEffect(() => {
        getInitialValues();
        setTitlePage('Permisos');
    }, [])




    return (
        <div>
            <Toast ref={toast} style={{ zIndex: 50000 }} />
            <ConfirmDialog />
            <Card
                titulo={<div className={'dflex'} style={{ display: 'flex', gap: 10 }}>
                    <h3>Aprobar permisos personal</h3>
                    <div style={{ display: 'flex', gap: 10 }}>

                        <Button icon='pi pi-search' onClick={getInfo} />
                        <Button icon='pi pi-plus' onClick={showModal} />
                        <Button icon='pi pi-trash' onClick={() => {
                            confirmDialog({
                                message: `Desea cancelar ${selected.length} permisos?`,
                                header: 'Confirmation',
                                icon: 'pi pi-exclamation-triangle',
                                accept: async () => {
                                    setLoading(true);
                                    const a = cancelarPermisos(selected);
                                    getInfo()
                                },
                                reject: () => { }
                            })
                        }} />
                    </div>

                </div>}
                contenido={<div style={{ height: '90vh', paddingTop: 20 }}>
                    <AgGrid table={table} />
                </div>
                }
            />

            <Dialog visible={show} onHide={onHide}
                header={<div><h3>Crear Permiso</h3></div>}
                footer={FooterCrear}
                style={{ zIndex: 1000 }}
            >
                <div style={{ width: '60vw', minWidth: 500 }}>
                    <Toast ref={toastDialog} style={{ zIndex: 50000 }} />
                    <div className='d-flex' style={{ alignitems: 'end', flexFlow: 'wrap', flexWrap: 'wrap' }} >
                        <div className={'col-6 field px-1 mt-3  mt-4'}>
                            <div className=' p-float-label'>
                                <Calendar
                                    name='FechaPermiso'
                                    showIcon
                                    placeholder='Fecha'
                                    value={values.FechaPermiso}
                                    onChange={handleInputChange}
                                    style={{ width: '100%' }}
                                    className={error.FechaPermiso ? 'p-invalid' : ''}
                                />
                                <label htmlFor="FechaPermiso">Fecha</label>

                            </div>
                            {error.FechaPermiso && <small className="p-error block" style={{ position: 'absolute' }}>Fecha no valida.</small>}
                        </div>
                        <div className={'col-6 field  px-1  mt-4'}>
                            <AutoCompleteDropdown
                                name={'Personal'}
                                value={values.Personal}
                                items={personal}
                                field={'Concat'}
                                label={'Persona'}
                                handleInputChange={handleInputChange}
                                abelStyle={{ color: 'gray', textShadow: '0px 0px 1px white' }}
                                className={error.Personal ? 'p-invalid' : ''}
                            />
                            {error.Personal && <small className="p-error block" style={{ position: 'absolute', top: 55 }}>Seleccione a la persona.</small>}
                        </div>
                        <div className={'col-6 field px-1  mt-4'}>
                            <AutoCompleteDropdown
                                name={'Tipo'}
                                value={values.Tipo}
                                items={tipoPermisos}
                                field={'Tipo'}
                                label={'Tipo de permiso'}
                                handleInputChange={handleInputChange}
                                abelStyle={{ color: 'gray', textShadow: '0px 0px 1px white' }}
                                className={error.Tipo ? 'p-invalid' : ''}
                            />
                            {error.Tipo && <small className="p-error block" style={{ position: 'absolute', top: 55 }}>Tipo de permiso no valido.</small>}
                        </div>

                        <div className={'col-6 field px-1  mt-4'}>
                            <AutoCompleteDropdown
                                name={'Autoriza'}
                                value={values.Autoriza}
                                items={listAutoriza}
                                field={'Nombre'}
                                label={'Autoriza'}
                                handleInputChange={handleInputChange}
                                abelStyle={{ color: 'gray', textShadow: '0px 0px 1px white' }}
                                className={error.Autoriza ? 'p-invalid' : ''}
                            />
                            {error.Autoriza && <small className="p-error block" style={{ position: 'absolute', top: 55 }}>Persona que autoriza no es valida.</small>}
                        </div>
                        <div className={'col-12 field px-1  mt-5'}>
                            {/* {formValues.Observaciones} */}
                            <div className='p-float-label'>
                                <InputText name='Observaciones' value={values.Observaciones} onChange={handleInputChange} style={{ width: '100%' }} />
                                <label htmlFor="FechaPermiso">Observaciones</label>
                            </div>
                            {error.Autoriza && <small className="p-error block" style={{}}>Persona que autoriza no es valida.</small>}
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={dialogAuth} onHide={onHide}
                header={<h3>Autorizar permisos personal</h3>}
                footer={
                    <div>
                        <Button label='Cancelar' className="p-button-success" onClick={onHide} />
                        <Button label='Aprobar' onClick={changePermiso} />
                    </div>
                }
            >
                <div style={{ width: 300 }}>
                    <p>
                        {selected.length} items selecionados para autorizar. <br />
                    </p>
                    <div style={{ height: 0, overflow: 'hidden' }}>
                        <input style={{ height: 0 }} />
                        <Password />
                    </div>
                    <Password
                        feedback={false}
                        toggleMask
                        autoComplete="off"
                        onChange={e => setPassword(e.target.value)}
                        value={password}
                        placeholder='Contraseña'
                    // className='col-12'
                    />
                </div>
            </Dialog>
        </div>
    )
}



export default AprobarPermisosPersonalGerencia